var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 153,
    viewBox: "0 0 136 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1318 12.0859C102.287 16.8052 115.105 26.8226 123.428 39.9788",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8382 122.366C8.73215 110.367 1.25488 93.7162 1.25488 75.3287C1.25488 54.7597 10.6237 36.3722 25.3557 24.2178",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2411 113.64C56.6254 113.64 58.5583 111.707 58.5583 109.322C58.5583 106.936 56.6254 105.003 54.2411 105.003C51.8567 105.003 49.9238 106.936 49.9238 109.322C49.9238 111.707 51.8567 113.64 54.2411 113.64Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4074 118.092C72.2667 87.6838 36.683 94.7183 29.4505 71.9009C23.6423 53.6247 52.3497 41.6261 64.2109 33.6344C77.0068 25.0195 80.9457 15.8035 78.431 1",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5183 118.092C32.9662 104.669 39.5311 98.2355 47.5647 94.3843C58.6026 89.1085 74.8255 85.1238 79.0315 71.9009C84.8397 53.6247 56.1324 41.6261 44.2712 33.6344C31.4753 25.0195 27.5364 15.8035 30.051 1",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.242 10.3052C56.6264 10.3052 58.5593 8.37168 58.5593 5.98658C58.5593 3.60148 56.6264 1.66797 54.242 1.66797C51.8577 1.66797 49.9248 3.60148 49.9248 5.98658C49.9248 8.37168 51.8577 10.3052 54.242 10.3052Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8037 5.98633H73.825",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9463 5.98633H49.9467",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4198 25.9321C56.8041 25.9321 58.737 23.9986 58.737 21.6135C58.737 19.2284 56.8041 17.2949 54.4198 17.2949C52.0354 17.2949 50.1025 19.2284 50.1025 21.6135C50.1025 23.9986 52.0354 25.9321 54.4198 25.9321Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9814 21.6133H71.221",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9961 21.6133H50.1021",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3838 29.2939H63.12",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9463 13.7998H74.5594",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8037 50.0625H63.1209",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3838 50.0625H49.9458",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6475 66.625H72.8453",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 66.625H49.9459",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6387 58.3213H71.8664",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9277 74.7725H72.3112",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4053 101.396H62.1193",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5586 109.321H68.5283",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9961 109.321H49.5681",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2411 54.3814C56.6254 54.3814 58.5583 52.4479 58.5583 50.0628C58.5583 47.6777 56.6254 45.7441 54.2411 45.7441C51.8567 45.7441 49.9238 47.6777 49.9238 50.0628C49.9238 52.4479 51.8567 54.3814 54.2411 54.3814Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2411 70.9439C56.6254 70.9439 58.5583 69.0103 58.5583 66.6252C58.5583 64.2401 56.6254 62.3066 54.2411 62.3066C51.8567 62.3066 49.9238 64.2401 49.9238 66.6252C49.9238 69.0103 51.8567 70.9439 54.2411 70.9439Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2411 87.2388C56.6254 87.2388 58.5583 85.3053 58.5583 82.9202C58.5583 80.5351 56.6254 78.6016 54.2411 78.6016C51.8567 78.6016 49.9238 80.5351 49.9238 82.9202C49.9238 85.3053 51.8567 87.2388 54.2411 87.2388Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8477 82.9199H62.8533",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.917 82.9199H49.9464",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3457 135.321H11.1133V151.995H18.3457V135.321Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9395 129.178H22.707V151.995H29.9395V129.178Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5342 123.612H34.3018V151.995H41.5342V123.612Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.128 119.205H45.8955V151.995H53.128V119.205Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7452 123.612H57.5127V151.995H64.7452V123.612Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3389 120.83H69.1064V151.995H76.3389V120.83Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9336 125.282H80.7012V151.995H87.9336V125.282Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5274 91.8906H92.2949V151.995H99.5274V91.8906Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M111.121 67.4033H103.889V151.995H111.121V67.4033Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.738 102.465H115.506V151.995H122.738V102.465Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.332 46.8125H127.1V151.995H134.332V46.8125Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrs);
export default __webpack_public_path__ + "static/media/PRS.363c80ee57870b8a3335c54bf90a4bfb.svg";
export { ForwardRef as ReactComponent };